<template>
<v-container>
  <v-card  >
    <v-row >
      <v-col cols="12">
        <h2>Templates</h2>
      </v-col>

      <v-col cols="12">
        <v-select
          :items="strutture"
          label="struttura"
          item-text="descrizione"
          item-value="id"
          v-model="dati.idstruttura"
          @input="setstruttura"
        ></v-select>
      </v-col>

      <v-skeleton-loader
        :loading="loading"
        height="94"
        type="list-item-two-line"
      >
        <v-col cols="12">
          <template  v-for="(item, index) in templates" >
          <v-card v-if="item.guidstrutturahr == dati.idstruttura" 
           @click="applytemplate(item)" :key="index" >
            <v-card-text>
              <v-col>
                <v-icon>mdi-text-box-multiple-outline</v-icon>
                {{item.descrizionetemplate}}
                
              </v-col>
            </v-card-text>
          </v-card>
          </template>
        </v-col>
        <v-col cols="12">
          <v-col>
            <v-text-field label="Salva Come" v-model="dati.descrizionetemplate" />
            <v-btn @click="Salva()">
              <v-icon>mdi-tag-plus</v-icon>
            </v-btn>
          </v-col>
        </v-col>
      </v-skeleton-loader>
    </v-row>
  </v-card>
</v-container>
</template>
<script>
import firebase from "firebase";
export default {
  data: () => ({
    loading: false,
    templates: [],
    strutture: [],
    dati: {
      idcliente: "cli1",
      id: "",
      descrizionetemplate: "",
      idstruttura:''
    }
  }),
  mounted() {
    this.carica();
  },
computed: {
  templates_struttura: function () {
    if(this.templates){
    return this.templates.filter(function (template) {
      return template.idstruttura  === this.dati.idstruttura
    })
    }
    else{
      return []
    }

  }
  },
  methods: {
    carica() {
      console.log("carico templates e strutture")
      this.loading = true;
      this.$store
        .dispatch("templates/fetchAndAdd", {
          where: [["idcliente", "==", firebase.auth().currentUser.uid]]
        })
        .then(data => {
          if (data) {
            this.templates = this.$store.state.templates.data;
            this.loading = false;
          }
        });
      this.$store
        .dispatch("strutture/fetchAndAdd", {
          where: [["idcliente", "==", firebase.auth().currentUser.uid]]
        })
        .then(data => {
          if (data) {
            this.strutture = Object.values(this.$store.state.strutture.data);
            this.dati.idstruttura = this.strutture[0].id
            this.loading = false;
            this.setstruttura()
          }
        });
    },
    applytemplate(item) {
      
      console.log("APPLICO TEMPLATE",item)
      this.$store.dispatch("applyTemplate", item.id).then(
        response => {
          console.log(response);
        },
        error => {
          console.error(error);
        }
      );
    },
    setstruttura(){
      this.$store.dispatch("SetStrutturaCorrente", this.dati.idstruttura)
    },
    Salva() {
      let me = this;
      this.$store.dispatch("saveAsTemplate", this.dati).then(x => {
        console.log(x);
        me.dati.descrizionetemplate = "";
      });
    }
  }
};
</script>